﻿export enum FeatureToggle {
  CheckIn = 'CHECK_IN',
  ExtrasFeature = 'EXTRAS',
  HybridMeetingsCalendarView = 'HYBRID_MEETINGS_CALENDAR_VIEW',
  ManualCheckIn = 'MANUAL_CHECK_IN',
  Occupancy = 'OCCUPANCY_SENSOR',
  Parking = 'PARKING',
  ProfilePictures = 'PROFILE_PICTURES',
  CustomerBranding = 'CUSTOMER_BRANDING',
  WalletIntegration = 'ACCESS_CONTROL',
  EmployeeCommunication = 'EMPLOYEE_COMMUNICATION',
  Controls = 'CONTROLS',
  // temporary
  ContextAwareExtras = 'RELEASE_2025-06-18_SERVICES',
  DarkMode = 'fe_dark-mode_temp_2022-09-20',
  ThreeDMaps = 'RELEASE_2023-08-21_3D_MAPS',
  ThreeDMapsMobile = 'RELEASE_2024-04-24_3D_MAPS_MOBILE',
  ThreeDMapsAsDefault = '3D_MAPS_AS_DEFAULT',
  MapsUsabilityVariants = 'MAPS_USABILITY_VARIANT_B',

  IntercomChat = 'RELEASE_2025-02-19_INTERCOM_CHAT',
  WorkspacesOnHereAndNow = 'OCCUPANCY_SENSOR', // temporary solution
  AppHomePage_DebugTime = 'DEV_2024-02-14_APP_HOMEPAGE_DEBUG_TIME',

  OnboardingReset = 'ONBOARDING_RESET',
  AppLinks = 'RELEASE_2025-01-14_APP_LINKS',
  AppLinks_Debug = 'DEV_2025-01-15_APP_LINKS_DEBUG',

  TimeslotsApi = 'RELEASE_2025-05-16_TIMESLOTS_API',
}
